<template>
  <div class="dashboard-wrapper">
    <!-- Indicadores Resumidos -->
    <div class="dashboard-summary">
      <div class="summary-card">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 11L20 4L13 21L11 13L3 11Z" />
        </svg>

        <div class="summary-value">{{ metrics.totalEnviadas || 0 }}</div>
        <div class="summary-label">Mensagens Enviadas</div>
      </div>

      <div class="summary-card">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M5 5H19C20.1 5 21 5.9 21 7V13C21 14.1 20.1 15 19 15H11L7 19V15H5C3.9 15 3 14.1 3 13V7C3 5.9 3.9 5 5 5Z"
          />
          <path d="M9 10.5L11 12.5L15 8.5" />
        </svg>

        <div class="summary-value">{{ metrics.totalRespondidas || 0 }}</div>
        <div class="summary-label">Respondidas</div>
      </div>

      <div class="summary-card">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M5 5H19C20.1 5 21 5.9 21 7V13C21 14.1 20.1 15 19 15H11L7 19V15H5C3.9 15 3 14.1 3 13V7C3 5.9 3.9 5 5 5Z"
          />
          <line x1="10" y1="8.5" x2="14" y2="12" />
          <line x1="14" y1="8.5" x2="10" y2="12" />
        </svg>

        <div class="summary-value">{{ metrics.totalNaoRespondidas || 0 }}</div>
        <div class="summary-label">Não Respondidas</div>
      </div>

      <div class="summary-card">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="7" cy="8" r="2" />
          <circle cx="17" cy="16" r="2" />
          <line x1="9" y1="15" x2="15" y2="9" />
        </svg>

        <div class="summary-value">{{ metrics.taxaGeral || 0 }}%</div>
        <div class="summary-label">Taxa de Resposta</div>
      </div>
    </div>

    <!-- 🔹 Gráficos -->
    <div class="dashboard-charts">
      <div class="chart-box">
        <canvas id="chartResumoMensagens" ref="chartResumoCanvas"></canvas>
      </div>
      <div class="chart-box">
        <canvas id="chartComparativoMensagens" ref="chartComparativoCanvas"></canvas>
      </div>
    </div>
  </div>

  <!-- Bloqueio caso não autenticado no WhatsApp -->
  <WhatsappBlocker v-if="!whatsappAutenticado" />
</template>

<script>
import { Chart, registerables } from "chart.js";
import { getAuth } from "firebase/auth";
import { secureFetch } from "@/main.js";
import WhatsappBlocker from "@/components/WhatsappBlocker.vue";
import { logout } from "@/utils/sessionUtils";

function storageKey(key, uid) {
  return `magleads:${uid}:${key}`;
}
async function getUid() {
  const auth = getAuth();
  const user = auth.currentUser;
  return user?.uid || "anonymous";
}

Chart.register(...registerables);
Chart.defaults.devicePixelRatio = 2;

const apiBaseUrl =
  process.env.VUE_APP_API_BASE_URL || "https://177.36.4.221:3000";

export default {
  name: "UserDashboard",
  components: { WhatsappBlocker },
  props: {
    preparedContacts: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["prepare-send", "add-card-to-kanban", "update-metrics"],
  data() {
    return {
      metrics: {},
      chartResumo: null,
      chartComparativo: null,
      waReadyFlag: false,
      uidCache: null,
    };
  },

  async mounted() {
    this.uidCache = await getUid();
    window.addEventListener("storage", this.onStorageChange);

    await this.ensureWhatsAppReady();

    if (this.whatsappAutenticado) {
      await this.loadDashboardMetrics();
    }
  },

  beforeUnmount() {
    window.removeEventListener("storage", this.onStorageChange);

    if (this.chartResumo) {
      this.chartResumo.destroy();
      this.chartResumo = null;
    }
    if (this.chartComparativo) {
      this.chartComparativo.destroy();
      this.chartComparativo = null;
    }
  },

  methods: {
    async resolveUserEmail() {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user?.email) return user.email;

      return (
        localStorage.getItem("email_ini") ||
        localStorage.getItem("ssoEmail") ||
        null
      );
    },

    onStorageChange(e) {
      if (
        e.key?.includes("magleads:") ||
        e.key === "qrCodeScanned" ||
        e.key === "acessoComWhatsapp"
      ) {
        const uid = this.uidCache || "anonymous";
        const a =
          localStorage.getItem(storageKey("acessoComWhatsapp", uid)) === "true";
        const q =
          localStorage.getItem(storageKey("qrCodeScanned", uid)) === "true";
        this.waReadyFlag = a && q;
        this.$forceUpdate();
      }

      if (
        this.whatsappAutenticado &&
        !this.chartResumo &&
        !this.chartComparativo
      ) {
        this.loadDashboardMetrics();
      }
    },

    async ensureWhatsAppReady() {
      try {
        const resp = await secureFetch(`${apiBaseUrl}/whatsapp-status`, {
          method: "GET",
        });
        const data = await resp.json();

        const uid = this.uidCache || (await getUid());

        if (data.status === "ready") {
          localStorage.setItem(storageKey("qrCodeScanned", uid), "true");
          localStorage.setItem(storageKey("acessoComWhatsapp", uid), "true");
          localStorage.removeItem("qrCodeScanned");
          localStorage.removeItem("acessoComWhatsapp");
          this.waReadyFlag = true;
        } else {
          localStorage.setItem(storageKey("qrCodeScanned", uid), "false");
          localStorage.setItem(storageKey("acessoComWhatsapp", uid), "false");
          this.waReadyFlag = false;
        }
      } catch (e) {
        console.warn("ensureWhatsAppReady falhou:", e.message);
      }
    },

    async loadDashboardMetrics() {
      try {
        const rawEmail = await this.resolveUserEmail();

        if (!rawEmail) {
          console.warn("⚠️ Nenhum e-mail (Firebase ou SSO) ao carregar dashboard.");
          this.$router.push("/");
          return;
        }

        const email = encodeURIComponent(rawEmail);
        const response = await secureFetch(
          `${apiBaseUrl}/get-dashboard-metrics?email=${email}`,
          { method: "GET" }
        );

        if (!response) {
          console.error("❌ secureFetch não retornou response.");
          return;
        }

        if (!response.ok) {
          let error = await response.json().catch(() => ({}));

          console.log("response.status =", response.status);
          console.log("erro completo=", error);
          console.log("errorCode=", error.code);

          if (error.code === "WHATSAPP_SESSION_EXPIRED") {
            alert("Sessão do whatsapp expirada. Faça login novamente");

            logout();
            return;
          }
          return;
        }

        const raw = await response.json();

        console.log("📊 Dados brutos do /get-dashboard-metrics:", raw);

        const totalEnviadas = Number(
          raw.totalEnviadas ??
          raw.total_enviadas ??
          raw.totalMensagens ??
          raw.total_sent ??
          0
        );

        const totalRespondidas = Number(
          raw.totalRespondidas ??
          raw.total_respondidas ??
          raw.totalRespondidasHoje ??
          raw.total_replied ??
          0
        );

        const safeTotalEnviadas = Math.max(0, totalEnviadas);
        const safeTotalRespondidas = Math.max(0, totalRespondidas);
        const totalNaoRespondidas = Math.max(0, safeTotalEnviadas - safeTotalRespondidas);


        const taxaGeral =
          raw.taxaGeral ??
          raw.taxa_geral ??
          raw.taxaResposta ??
          raw.taxa_resposta_geral ??
          0;

        const historicoRaw = raw.historico ?? raw.history ?? [];
        const historico = Array.isArray(historicoRaw) ? historicoRaw : [];

        const normalized = {
          totalEnviadas: safeTotalEnviadas,
          totalRespondidas: safeTotalRespondidas,
          totalNaoRespondidas,
          taxaGeral,
          historico,
        };

        this.metrics = normalized;

        await this.$nextTick();
        this.renderCharts(normalized);
      } catch (err) {
        console.error("❌ Erro ao carregar métricas:", err);
      }
    },

    renderCharts(metrics) {
      const {
        totalEnviadas,
        totalRespondidas,
        totalNaoRespondidas,
        historico,
      } = metrics;

      const canvasResumo = this.$refs.chartResumoCanvas;
      const canvasComparativo = this.$refs.chartComparativoCanvas;

      if (!canvasResumo || !canvasComparativo) {
        console.warn("⚠️ Canvas de gráficos não encontrados.");
        return;
      }

      const ctxResumo = canvasResumo.getContext("2d");
      const ctxComparativo = canvasComparativo.getContext("2d");

      if (!ctxResumo || !ctxComparativo) {
        console.warn("⚠️ getContext('2d') retornou null.");
        return;
      }

      if (this.chartResumo) {
        this.chartResumo.destroy();
        this.chartResumo = null;
      }
      if (this.chartComparativo) {
        this.chartComparativo.destroy();
        this.chartComparativo = null;
      }

      this.chartResumo = new Chart(ctxResumo, {
        type: "pie",
        data: {
          labels: ["Respondidas", "Não Respondidas", "Enviadas"],
          datasets: [
            {
              data: [totalRespondidas, totalNaoRespondidas, totalEnviadas],
              backgroundColor: ["#28a745", "#dc3545", "#080808"],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2,
          animation: false,
          plugins: {
            title: {
              display: true,
              text: "Mensagens",
              font: { size: 18 },
            },
            legend: { position: "bottom" },
          },
        },
      });

      const labels = historico.map((r) =>
        new Date(r.dia).toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
        })
      );
      const enviadas = historico.map((r) => r.enviadas ?? r.total_enviadas ?? 0);
      const respondidas = historico.map(
        (r) => r.respondidas ?? r.total_respondidas ?? 0
      );
      const taxa = historico.map((r) =>
        Number((r.taxa_resposta ?? r.taxa ?? 0).toFixed(1))
      );

      this.chartComparativo = new Chart(ctxComparativo, {
        data: {
          labels,
          datasets: [
            {
              type: "bar",
              label: "Mensagens Enviadas",
              data: enviadas,
              backgroundColor: "#080808",
            },
            {
              type: "bar",
              label: "Mensagens Respondidas",
              data: respondidas,
              backgroundColor: "#28a745",
            },
            {
              type: "line",
              label: "Taxa de Resposta (%)",
              data: taxa,
              borderColor: "#ffc107",
              backgroundColor: "#ffc107",
              yAxisID: "y1",
              tension: 0.3,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2,
          animation: false,
          plugins: {
            title: { display: true, text: "Comparativo", font: { size: 18 } },
            legend: { position: "bottom" },
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "Mensagens" },
            },
            y1: {
              beginAtZero: true,
              position: "right",
              grid: { drawOnChartArea: false },
              title: { display: true, text: "Taxa (%)" },
            },
          },
        },
      });
    },
  },

  computed: {
    whatsappAutenticado() {
      const uid = this.uidCache || "anonymous";
      const a =
        localStorage.getItem(storageKey("acessoComWhatsapp", uid)) === "true";
      const q =
        localStorage.getItem(storageKey("qrCodeScanned", uid)) === "true";

      const aLegacy = localStorage.getItem("acessoComWhatsapp") === "true";
      const qLegacy = localStorage.getItem("qrCodeScanned") === "true";

      return (a && q) || (aLegacy && qLegacy) || this.waReadyFlag === true;
    },
  },
};
</script>

<style src="@/assets/styleDashboard.css"></style>
